module.exports = __webpack_public_path__ + "img/upload_cell_small.b45e5ff0.gif";